module.exports = __webpack_public_path__ + "img/image-7.82dbb9c3.png";